/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setCountry} from '../api'

export const useMutationSetCountry = createReactQueryMutationHook('setCountry', setCountry)
